var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "48ba122611"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 216.394531 152.90625 L 252.066406 152.90625 L 252.066406 192.757812 L 216.394531 192.757812 Z M 216.394531 152.90625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8493a34462"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 234.230469 152.90625 C 224.378906 152.90625 216.394531 161.796875 216.394531 172.761719 C 216.394531 183.730469 224.378906 192.617188 234.230469 192.617188 C 244.082031 192.617188 252.066406 183.730469 252.066406 172.761719 C 252.066406 161.796875 244.082031 152.90625 234.230469 152.90625 Z M 234.230469 152.90625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7d3f53a725"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 145.296875 96.226562 L 205.523438 96.226562 L 205.523438 144.554688 L 145.296875 144.554688 Z M 145.296875 96.226562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "06ecb020a4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 175.359375 96.226562 C 158.757812 96.226562 145.296875 107.042969 145.296875 120.390625 C 145.296875 133.738281 158.757812 144.554688 175.359375 144.554688 C 191.960938 144.554688 205.421875 133.738281 205.421875 120.390625 C 205.421875 107.042969 191.960938 96.226562 175.359375 96.226562 Z M 175.359375 96.226562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b7f5691902"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 126.71875 195.902344 L 192.050781 195.902344 L 192.050781 257.167969 L 126.71875 257.167969 Z M 126.71875 195.902344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "95a47b9eb6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.363281 195.902344 C 141.335938 195.902344 126.71875 209.617188 126.71875 226.535156 C 126.71875 243.453125 141.335938 257.167969 159.363281 257.167969 C 177.394531 257.167969 192.011719 243.453125 192.011719 226.535156 C 192.011719 209.617188 177.394531 195.902344 159.363281 195.902344 Z M 159.363281 195.902344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b8e6f652b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.363281 152.898438 L 216.402344 152.898438 L 216.402344 166.246094 L 159.363281 166.246094 Z M 159.363281 152.898438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "225b76bda8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.363281 159.570312 C 159.363281 157.800781 160.066406 156.105469 161.320312 154.851562 C 162.570312 153.601562 164.265625 152.898438 166.039062 152.898438 L 209.71875 152.898438 C 211.488281 152.898438 213.1875 153.601562 214.4375 154.851562 C 215.691406 156.105469 216.394531 157.800781 216.394531 159.570312 C 216.394531 161.339844 215.691406 163.039062 214.4375 164.289062 C 213.1875 165.542969 211.488281 166.246094 209.71875 166.246094 L 166.039062 166.246094 C 164.265625 166.246094 162.570312 165.542969 161.320312 164.289062 C 160.066406 163.039062 159.363281 161.339844 159.363281 159.570312 Z M 159.363281 159.570312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "71c5addf27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.355469 157.125 L 172.703125 157.125 L 172.703125 214.164062 L 159.355469 214.164062 Z M 159.355469 157.125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7004ad336a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 166.027344 214.164062 C 164.257812 214.164062 162.5625 213.460938 161.308594 212.210938 C 160.058594 210.957031 159.355469 209.261719 159.355469 207.488281 L 159.355469 163.808594 C 159.355469 162.039062 160.058594 160.339844 161.308594 159.089844 C 162.5625 157.835938 164.257812 157.132812 166.027344 157.132812 C 167.800781 157.132812 169.496094 157.835938 170.75 159.089844 C 172 160.339844 172.703125 162.039062 172.703125 163.808594 L 172.703125 207.488281 C 172.703125 209.261719 172 210.957031 170.75 212.210938 C 169.496094 213.460938 167.800781 214.164062 166.027344 214.164062 Z M 166.027344 214.164062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "958b13f3b7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 160.15625 200.828125 L 203.796875 200.828125 L 203.796875 214.175781 L 160.15625 214.175781 Z M 160.15625 200.828125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5fb458b07b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 203.796875 207.5 C 203.796875 209.269531 203.09375 210.96875 201.84375 212.21875 C 200.589844 213.472656 198.894531 214.175781 197.121094 214.175781 L 166.84375 214.175781 C 165.074219 214.175781 163.378906 213.472656 162.125 212.21875 C 160.875 210.96875 160.171875 209.269531 160.171875 207.5 C 160.171875 205.730469 160.875 204.03125 162.125 202.78125 C 163.378906 201.53125 165.074219 200.828125 166.84375 200.828125 L 197.121094 200.828125 C 198.894531 200.828125 200.589844 201.53125 201.84375 202.78125 C 203.09375 204.03125 203.796875 205.730469 203.796875 207.5 Z M 203.796875 207.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "00a3a2f860"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 192.265625 175.242188 L 205.613281 175.242188 L 205.613281 213.410156 L 192.265625 213.410156 Z M 192.265625 175.242188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5af944574b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 198.9375 213.410156 C 197.167969 213.410156 195.46875 212.707031 194.21875 211.453125 C 192.96875 210.203125 192.265625 208.503906 192.265625 206.734375 L 192.265625 181.941406 C 192.265625 180.171875 192.96875 178.472656 194.21875 177.222656 C 195.46875 175.96875 197.167969 175.265625 198.9375 175.265625 C 200.707031 175.265625 202.40625 175.96875 203.65625 177.222656 C 204.910156 178.472656 205.613281 180.171875 205.613281 181.941406 L 205.613281 206.734375 C 205.613281 208.503906 204.910156 210.203125 203.65625 211.453125 C 202.40625 212.707031 200.707031 213.410156 198.9375 213.410156 Z M 198.9375 213.410156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0dc0bb76a2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 88.816406 96.226562 L 261.980469 96.226562 L 261.980469 261.261719 L 88.816406 261.261719 Z M 88.816406 96.226562 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#48ba122611)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8493a34462)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#38b6ff",
    d: "M 216.394531 152.90625 L 252.066406 152.90625 L 252.066406 192.617188 L 216.394531 192.617188 Z M 216.394531 152.90625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7d3f53a725)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#06ecb020a4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#38b6ff",
    d: "M 145.296875 96.226562 L 205.335938 96.226562 L 205.335938 144.554688 L 145.296875 144.554688 Z M 145.296875 96.226562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b7f5691902)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#95a47b9eb6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#38b6ff",
    d: "M 126.71875 195.902344 L 192.050781 195.902344 L 192.050781 257.167969 L 126.71875 257.167969 Z M 126.71875 195.902344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b8e6f652b3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#225b76bda8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 159.363281 166.246094 L 159.363281 152.898438 L 216.402344 152.898438 L 216.402344 166.246094 Z M 159.363281 166.246094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#71c5addf27)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7004ad336a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 172.703125 214.164062 L 159.355469 214.164062 L 159.355469 157.125 L 172.703125 157.125 Z M 172.703125 214.164062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#958b13f3b7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5fb458b07b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 203.796875 200.828125 L 203.796875 214.175781 L 160.15625 214.175781 L 160.15625 200.828125 Z M 203.796875 200.828125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#00a3a2f860)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5af944574b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 205.613281 213.410156 L 192.265625 213.410156 L 192.265625 175.242188 L 205.613281 175.242188 Z M 205.613281 213.410156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0dc0bb76a2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 258.910156 151.316406 C 249.542969 116.835938 221.21875 96.25 183.128906 96.25 L 88.816406 96.25 L 90.679688 100.515625 C 98.671875 118.835938 116.757812 130.679688 136.75 130.683594 L 162.429688 130.683594 L 162.640625 130.679688 C 163.617188 130.609375 167.222656 130.390625 172.632812 130.390625 C 177.835938 130.390625 183.136719 130.59375 188.371094 130.996094 L 188.886719 131.035156 C 208.921875 132.613281 236.375 137.851562 253.335938 153.820312 L 253.554688 154.023438 C 253.644531 154.109375 253.734375 154.191406 253.816406 154.277344 L 261.890625 162.316406 Z M 261.492188 191.058594 L 261.46875 191.390625 C 256.375 234.351562 226.035156 261.039062 182.289062 261.039062 L 122.121094 261.039062 L 122.121094 179.699219 L 125.164062 179.699219 C 142.78125 179.699219 157.109375 194.03125 157.109375 211.644531 L 157.109375 226.046875 L 183.757812 226.046875 C 196.882812 226.046875 207.933594 221.738281 215.722656 213.582031 C 223.648438 205.28125 227.839844 193.285156 227.839844 178.890625 L 227.839844 178.398438 C 227.839844 167.253906 225.386719 157.644531 220.550781 149.832031 L 216.039062 142.539062 L 224.140625 145.351562 C 234.191406 148.839844 242.347656 153.484375 248.375 159.160156 C 257.183594 167.457031 261.59375 178.1875 261.492188 191.058594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/CompanyLogo.64ea855514bfbd4cd4d4536c55922b3e.svg";
export { ForwardRef as ReactComponent };